import React from "react";
import { Button, IconButton } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import colors from "../../assets/theme/colors";

const iconButtonSx = {
  width: 40,
  height: 40,
  borderRadius: 2.25,
  bgcolor: colors.landing.surfaceSoft,
  border: `1px solid ${colors.landing.borderLight}`,
  boxShadow: `0 4px 10px ${colors.landing.shadowSoft}`,
  color: colors.landing.heroText,
  "&:hover": { bgcolor: colors.landing.panelSoft },
};

const CareProfileBackButton = ({
  onClick,
  disabled = false,
  ariaLabel = "Go back",
  label = "",
  sx = {},
}) => {
  if (label) {
    return (
      <Button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        startIcon={<ArrowBackRoundedIcon sx={{ fontSize: 20 }} />}
        sx={{
          alignSelf: "flex-start",
          minHeight: 40,
          px: 1,
          borderRadius: 2.25,
          textTransform: "none",
          fontWeight: 500,
          color: colors.landing.heroText,
          "&:hover": { bgcolor: colors.landing.panelSoft },
          ...sx,
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <IconButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      sx={{ ...iconButtonSx, ...sx }}
    >
      <ArrowBackRoundedIcon sx={{ fontSize: 20 }} />
    </IconButton>
  );
};

export default CareProfileBackButton;
